<template>
    <!--     
    <v-speed-dial location="left bottom" transition="false"  scrim>
        <template v-slot:activator="{ props }">
            <v-fab id="insert_in_map" v-bind="props" color="green-darken-3" dark size="x-large"
        icon="mdi-plus" />
    </template>

<template v-for="(possibilita, i) in dataStore.ventaglio_possibili_filtered" :key="possibilita.geometryType+'_'+i">
    <v-btn :value="possibilita" :color="possibilita.color" variant="flat" size="default"
class="mx-auto" width="100%" @click="emitInsert(possibilita); isActive.value = false">
{{ possibilita.descrizione }}
</v-btn>
</template>
</v-speed-dial> -->



    <v-bottom-sheet v-model="sheet" :inset="!mobile">
        <!-- <v-bottom-sheet v-model="sheet" :inset="!mobile" :attach="'#the_map'"> -->
        <template v-slot:activator="{ props }">
            <v-fab id="insert_in_map" v-bind="props" color="green-darken-3" dark size="x-large" icon="mdi-plus" />
        </template>
        <template v-slot:default>

            <v-card theme="dark" class="text-center" id="card">

                <v-card-text class="d-flex flex-column">

                    <div v-if="false">

                        <v-tabs-window v-model="tab">
                            <v-tabs-window-item value="Point" class="d-flex flex-wrap ga-3 justify-center">
                            <v-btn v-for="(possibilita, i) in points" :key="'point_' + i" :value="possibilita"
                                :color="possibilita.color" variant="flat" size="default" :block="mobile"
                                :width="mobile ? 'auto' : '20em'" @click="emitInsert(possibilita);">
                                {{ i }} {{ possibilita.descrizione }}
                            </v-btn>
                        </v-tabs-window-item>

                        <v-tabs-window-item value="LineString" class="d-flex flex-wrap ga-3 justify-center">
                            <v-btn v-for="(possibilita, i) in lines" :key="'line_' + i" :value="possibilita"
                                :color="possibilita.color" variant="flat" size="default" :block="mobile"
                                :width="mobile ? 'auto' : '20em'" @click="emitInsert(possibilita);">
                                {{ i }} {{ possibilita.descrizione }}
                            </v-btn>
                        </v-tabs-window-item>

                        <!-- <v-tabs-window-item value="Polygon" class="d-flex flex-wrap ga-3 justify-center">
                            <v-btn v-for="(possibilita, i) in areas" :key="'area_' + i" :value="possibilita"
                                :color="possibilita.color" variant="flat" size="default" :block="mobile"
                                :width="mobile ? 'auto' : '20em'" @click="emitInsert(possibilita);">
                                {{ i }} {{ possibilita.descrizione }}
                            </v-btn>
                        </v-tabs-window-item> -->
                    </v-tabs-window>
                </div>


                    
                    <!-- 
                    
                    il v-tab sembra buggato (fa vedere tutto)
                    eventualmente provare il <v-carousel>
                    per ora uso il mio custom show/hide
                    -->
                    <div v-if="true">

                        <v-fade-transition>
                            <v-container v-if="tab == 'Point'" class="d-flex flex-wrap ga-5 justify-center">
                            <v-btn v-for="(possibilita, i) in points" :key="'point_' + i" :value="possibilita"
                                :color="possibilita.color" variant="flat" size="default" :block="mobile"
                                :width="mobile ? 'auto' : '20em'" @click="emitInsert(possibilita);">
                                <!-- {{ i }}  -->
                                {{ possibilita.descrizione }}
                            </v-btn>
                        </v-container>

                    </v-fade-transition>

                    <v-fade-transition>
                        <v-container v-if="tab == 'LineString'" class="d-flex flex-wrap ga-3 justify-center">
                            <v-btn v-for="(possibilita, i) in lines" :key="'line_' + i" :value="possibilita"
                                :color="possibilita.color" variant="flat" size="default" :block="mobile"
                                :width="mobile ? 'auto' : '20em'" @click="emitInsert(possibilita);">
                                <!-- {{ i }}  -->
                                {{ possibilita.descrizione }}
                            </v-btn>
                        </v-container>

                    </v-fade-transition>

                    <v-fade-transition>
                        <v-container v-if="tab == 'Polygon'" class="d-flex flex-wrap ga-3 justify-center">
                            <v-btn v-for="(possibilita, i) in areas" :key="'area_' + i" :value="possibilita"
                                :color="possibilita.color" variant="flat" size="default" :block="mobile"
                                :width="mobile ? 'auto' : '20em'" @click="emitInsert(possibilita);">
                                <!-- {{ i }}  -->
                                {{ possibilita.descrizione }}
                            </v-btn>
                        </v-container>
                        
                    </v-fade-transition>
                </div>

                </v-card-text>
                <v-card-actions
                    class="position-sticky bottom-0 ma-0 bg-grey-darken-4 d-flex flex-column justify-center">

                    <!-- <v-card-title>Inserisci</v-card-title> -->
                    <v-tabs bg-color="grey-darken-3" fixed-tabs v-model="tab" color="lime" class="w-100">
                        <v-tab value="Point">
                            <v-icon class="py-8" size="large">mdi-map-marker</v-icon>
                        </v-tab>
                        <v-tab value="LineString">
                            <v-icon class="py-8" size="large">mdi-vector-polyline</v-icon>
                        </v-tab>
                        <v-tab value="Polygon" v-if="runtimeStore.session.user?.username=='marco'|| runtimeStore.session.user?.username=='peracino_a'">
                            <v-icon class="py-8" size="large">mdi-vector-square</v-icon>
                        </v-tab>
                    </v-tabs>
                    <v-btn size="large" class="my-2" variant="outlined" color="white" @click="sheet = !sheet">
                        <v-icon>mdi-chevron-down</v-icon>
                        Indietro</v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-bottom-sheet>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRuntimeStore } from "@/store/runtime"
import { useDataStore } from "@/store/data";

import { useDisplay } from 'vuetify'
const { mobile } = useDisplay()

const dataStore = useDataStore();


const sheet = ref(false)

const emit = defineEmits(['onInsert'])

const emitInsert = (possibilita) => {
    console.log('🔈 inserting', possibilita)
    emit('onInsert', possibilita)
}

const runtimeStore = useRuntimeStore();


// const selected = ref(250)


const tab = ref("Point")


const points = computed(() =>
    dataStore.ventaglio_possibili_filtered.filter(possibilita => possibilita.geometryType === 'Point')
    )

const lines = computed(() =>
    dataStore.ventaglio_possibili_filtered.filter(possibilita => possibilita.geometryType === 'LineString')
    )

const areas = computed(() =>
    dataStore.ventaglio_possibili_filtered.filter(possibilita => possibilita.geometryType === 'Polygon')
    )


onMounted(() => {
    if (!runtimeStore.session.settings.showInsertType) {
        runtimeStore.session.settings.showInsertType = {}
        for (const possibilita of dataStore.ventaglio_possibili) {
            runtimeStore.session.settings.showInsertType[possibilita.modelCamel] = false
        }
        runtimeStore.saveSession()
    }
})

</script>

<style scoped>
.v-speed-dial__content {
    background: #0006;
    padding: 2em;
    margin-bottom: 2em;
}

.v-btn {
    pointer-events: auto;
}



.v-card-actions {
    z-index: 1006;
}
</style>
